// plugins/sentry.client.ts
import * as Sentry from '@sentry/vue'

export default defineNuxtPlugin(nuxtApp => {
  const runtimeConfig = useRuntimeConfig()
  const route = useRoute()
  const {vueApp} = nuxtApp

  Sentry.init({
    app: [vueApp],
    dsn: runtimeConfig.public.sentryDsn,
    integrations: [
      Sentry.browserTracingIntegration(),
      Sentry.replayIntegration({
        maskAllText: false,
        blockAllMedia: false
      })
    ],
    tracePropagationTargets: ['localhost', /^https:\/\/api-dev\.guardianns\.com/],
    tracesSampleRate: 1.0,
    replaysSessionSampleRate: 0,
    replaysOnErrorSampleRate: 1.0,
    beforeSend(event, hint) {
      const error = hint.originalException
      if (error && error.message && error.message.match(/(401|419)/)) return null
      if (event.exception) {
        console.error(`[Exeption handled by Sentry]: (${hint.originalException})`, {event, hint})
      }
      return event
    }
  })

  Sentry.attachErrorHandler(vueApp, {
    logErrors: false,
    attachProps: true,
    trackComponents: true,
    timeout: 2000,
    hooks: ['activate', 'mount', 'update']
  })

  return {
    provide: {
      sentrySetContext: (n, context) => Sentry.setContext(n, context),
      sentrySetUser: user => Sentry.setUser(user),
      sentrySetTag: (tagName, value) => Sentry.setTag(tagName, value),
      sentryAddBreadcrumb: breadcrumb => Sentry.addBreadcrumb(breadcrumb),
      sentryCaptureException: exception => Sentry.captureException(exception)
    }
  }
})
